var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoordination(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("line", {
    x1: 0.501,
    y1: 4.49,
    x2: 19.933,
    y2: 4.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.501,
    y1: 12.978,
    x2: 9.055,
    y2: 12.978
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.501,
    y1: 8.74,
    x2: 14.128,
    y2: 8.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.438,
    y1: 4.49,
    x2: 8.438,
    y2: 17.37
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.128,
    y1: 4.49,
    x2: 14.128,
    y2: 9.702
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.615,18.135A1.535,1.535,0,1,0,16.143,16.6,1.5,1.5,0,0,0,17.615,18.135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.864,10.674l.434,1.484a.971.971,0,0,0,1.152.7l1.445-.349a1.3,1.3,0,0,1,1.429.653,1.415,1.415,0,0,1-.178,1.616l-1.012,1.133a1.054,1.054,0,0,0,0,1.392l1.012,1.136a1.413,1.413,0,0,1,.177,1.614A1.294,1.294,0,0,1,21.9,20.7l-1.445-.348a.97.97,0,0,0-1.152.7l-.434,1.481a1.291,1.291,0,0,1-2.5,0l-.434-1.484a.971.971,0,0,0-1.152-.7l-1.444.349a1.294,1.294,0,0,1-1.428-.653,1.413,1.413,0,0,1,.177-1.614L13.094,17.3a1.052,1.052,0,0,0,0-1.392l-1.011-1.136a1.412,1.412,0,0,1-.178-1.615,1.294,1.294,0,0,1,1.429-.653l1.444.349a.971.971,0,0,0,1.152-.7l.434-1.485a1.291,1.291,0,0,1,2.5.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.173,17.366H2.551A2.044,2.044,0,0,1,.507,15.322V2.544A2.044,2.044,0,0,1,2.551.5H17.884a2.044,2.044,0,0,1,2.044,2.044V7.513"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordination);
export default __webpack_public_path__ + "static/media/coordination.891dca8a.svg";
export { ForwardRef as ReactComponent };